"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { submitting: false };
        this.fhandler = new FormHandler({
            key: 'add-user',
            autosave: true
        });
        this.fhandler.bind(this);
    },
    onMount: function () {
        const title = 'Adding User';
        this.fhandler.on('autosave', () => GState.activity.add({
            title,
            path: '/add-user'
        })).on('reset', () => GState.activity.remove(title));
    },
    onSelectAccountType: function (value) {
        if (value !== 'admin')
            delete this.state.form.userRole;
        this.fhandler.set('accountType', value);
    },
    onSubmit: async function () {
        const Form = this.state.form;
        if (!Form.fullname)
            return this.state.formError.fullname = true;
        if (!Form.email)
            return this.state.formError.email = true;
        if (!Form.accountType)
            return this.state.formError.accountType = true;
        this.state.submitting = true;
        try {
            const {error, message} = await Request('/invitation/send', 'POST', Form);
            this.state.submitting = false;
            this.fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            this.fhandler.reset();
        } catch (error) {
            this.state.submitting = false;
            this.fhandler.alert(error);
        }
    },
    onReset: function () {
        this.fhandler.reset();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Users/Admin/Add.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    index_template = require("/workspace/src/views/components/Wrapper/index.marko"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Bx_template = require("../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Select_template = require("../../../../components/Select/index.marko"),
    Select_tag = marko_loadTag(Select_template),
    get_context_template = require("@marko-tags/context/src/components/get-context/index.marko"),
    get_context_tag = marko_loadTag(get_context_template),
    FormAlert_template = require("../../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "text-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("c8af40"),
    marko_node0 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "5", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_node2 = marko_createElement("br", null, "22", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "font-small-4 text-right mt-2"
      },
    marko_attrs6 = {
        "class": "text-primary"
      },
    marko_attrs7 = {
        "class": "col-4 pr-50"
      },
    marko_attrs8 = {
        type: "reset",
        "class": "btn btn-light btn-xl w-100"
      },
    marko_attrs9 = {
        "class": "col pl-50"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      class: "d-flex justify-content-center",
      renderBody: function(out, { page, themeMode }) {
        WSAdapt_tag({
            qs: "col-xl-6",
            hs: "col-xl-9",
            class: "col-xl-5 col-lg-7 col-md-10",
            renderBody: function(out) {
              out.be("form", null, "@add-user", component);

              out.be("div", marko_attrs0, "2", component);

              Bx_tag({
                  type: "user",
                  class: "font-large-5"
                }, out, __component, "3");

              out.ee();

              out.n(marko_node0, component);

              out.n(marko_node1, component);

              out.be("div", marko_attrs1, "6", component);

              out.e("input", {
                  type: "text",
                  value: state.form.fullname,
                  name: "fullname",
                  "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.fullname != undefined ? state.formError.fullname ? " is-invalid" : " is-valid" : "")),
                  validate: "required",
                  placeholder: Locale("First & Last Name")
                }, "7", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2 " + (!state.formError.fullname ? " d-none" : ""))
                }, "8", component, null, 1);

              Locale_tag({
                  text: "Enter user's fullname is required"
                }, out, __component, "9");

              out.ee();

              out.ee();

              out.be("div", marko_attrs2, "10", component);

              out.e("input", {
                  type: "text",
                  value: state.form.email,
                  name: "email",
                  "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.email != undefined ? state.formError.email ? " is-invalid" : " is-valid" : "")),
                  validate: "required email",
                  placeholder: Locale("Email Address")
                }, "11", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2 " + (!state.formError.email ? " d-none" : ""))
                }, "12", component, null, 1);

              Locale_tag({
                  text: "Invalid Email Address"
                }, out, __component, "13");

              out.ee();

              out.ee();

              out.be("div", marko_attrs3, "14", component);

              Select_tag({
                  class: "rounded",
                  size: "xl",
                  value: state.form.accountType,
                  options: [
                      {
                          value: "admin",
                          label: "Administrator"
                        },
                      {
                          value: "instructor",
                          label: "Instructor"
                        },
                      {
                          value: "learner",
                          label: "Learner"
                        }
                    ],
                  placeholder: Locale("Add user as")
                }, out, __component, "15", [
                [
                  "select",
                  "onSelectAccountType",
                  false
                ]
              ]);

              out.ee();

              if (state.form.accountType == "admin") {
                out.be("div", marko_attrs4, "16", component);

                Select_tag({
                    class: "rounded",
                    size: "xl",
                    value: state.form.userRole,
                    name: "userRole",
                    options: [
                        {
                            value: "SUPER",
                            label: "SUPER ADMIN"
                          },
                        {
                            value: "SUPERVISOR",
                            label: "SUPERVISOR"
                          }
                      ],
                    placeholder: Locale("Give Administrator a Role")
                  }, out, __component, "17", [
                  [
                    "select",
                    "__onChange",
                    false
                  ]
                ]);

                get_context_tag({
                    __from: index_template,
                    renderBody: function(out, emit) {
                      out.be("p", marko_attrs5, "18", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Learn more about Administrator ");
                          }
                        }, out, __component, "19");

                      out.be("span", marko_attrs6, "20", component, null, 0, {
                          onclick: __component.d("click", emit, false, [
                              "onHelp",
                              "Topic-ID"
                            ])
                        });

                      Locale_tag({
                          text: "Roles & Permissions"
                        }, out, __component, "21");

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "32");

                out.ee();
              }

              out.n(marko_node2, component);

              FormAlert_tag({
                  alert: state.alert
                }, out, __component, "23");

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs7, "25", component);

                    out.be("button", marko_attrs8, "26", component, null, 0, {
                        onclick: __component.d("click", "onReset", false)
                      });

                    Locale_tag({
                        text: "Reset"
                      }, out, __component, "27");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs9, "28", component);

                    out.be("button", {
                        type: "submit",
                        "class": "btn btn-primary btn-xl w-100",
                        disabled: state.submitting
                      }, "29", component, null, 0, {
                        onclick: __component.d("click", "onSubmit", false)
                      });

                    Preloader_tag({
                        class: "float-right font-medium-5",
                        active: state.submitting
                      }, out, __component, "30");

                    Locale_tag({
                        text: "Submit"
                      }, out, __component, "31");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "24");

              out.ee();
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
